<template><div></div></template>

<script>
import localReferences from '@/helpers/localReferences';
import Echo from 'laravel-echo';

export default {
    name: 'Notifications',
    data() {
        return {
            notifications: {},
            audio: null
        };
    },
    mounted() {
        const echo = new Echo({
            namespace: '', //defaults to App.Event
            broadcaster: 'socket.io',
            host: '/',
            client: require('socket.io-client'),
            auth: { headers: { Authorization: this.$store.state.auth.token } }
        });

        echo.channel('public')
            .listen('.message.sent', (event) => {
                this.$message({
                    showClose: true,
                    message: event.data.message,
                    type: 'success',
                    duration: 5000
                });
            });
        if (this.$store.state.auth.id) {
            echo.private('user.' + this.$store.state.auth.id)
                .listen('.employer.informed', (event) => {
                    this.$message({
                        showClose: true,
                        message: event.data.message,
                        type: 'success',
                        duration: 5000
                    });
                })
                .listen('.employer.tasks.updated', (event) => {
                    this.$store.commit('metrics/setTasksMetrics', event);
                })
                .listen('.user.leads.created', (event) => {
                    this.$store.commit('metrics/setLeadsMetrics', event);
                })
                .listen('.user.income.cashless.newToFix.saved', (event) => {
                    this.$store.commit('metrics/setIncomesNewToFixCashLessMetrics', event);
                })
                .listen('.user.income.cashless.onCheck.saved', (event) => {
                    this.$store.commit('metrics/setIncomesOnCheckCashLessMetrics', event);
                })
                .listen('.voip.informed', (event) => {
                    const notification = JSON.parse(event.data);
                    this.showHideCallNotify(notification);
                });
        }
    },
    computed: {
        settings() {
            return this.$store.state.auth.settings;
        }
    },
    methods: {
        showHideCallNotify(notification) {
            if (this.settings && Object.prototype.hasOwnProperty.call(this.settings, 'show_call_popup') && this.settings.show_call_popup === 1) {
                if (notification) {
                    if (notification.active) {
                        if (!Object.prototype.hasOwnProperty.call(this.notifications, this.getNotifyQueueId(notification))) {
                            const notify = this.$notify({
                                queueId: this.getNotifyQueueId(notification),
                                title: 'Входящий звонок',
                                dangerouslyUseHTMLString: true,
                                message: this.getCard(notification),
                                position: 'bottom-right',
                                iconClass: 'orange el-icon-bell-anim',
                                duration: 0,
                                onClick: () => {
                                    this.getDataRoute(notification);
                                },
                                onClose: (notifyItem) => {
                                    if (Object.prototype.hasOwnProperty.call(this.notifications, notifyItem.queueId)) {
                                        this.notifications[notifyItem.queueId].closed = true;
                                    }
                                }
                            });
                            this.notifications[this.getNotifyQueueId(notification)] = {
                                notify: notify,
                                closed: false
                            };
                        }
                    } else {
                        this.closeNotify(this.getNotifyQueueId(notification));
                    }
                }
            }
        },
        getCard(notification) {
            let card = '';
            if (notification.queue) {
                card += '<div>Телефон: ' + notification.queue.src_num + '</div>';
            }
            if (notification.contact) {
                card += `<div class="link-listen"><b>Контакт:</b> ${notification.contact.name}</div>`;
            }
            if (notification.type === localReferences.entities.lead && notification.lead) {
                card += `<div class="link-listen card-route" data-route="lead-card" data-prop="${notification.lead.id}"><b>Лид:</b> ${notification.lead.id}</div>`;
                if (notification.lead.responsible_user) {
                    card += `<div class="link-listen"><b>Ответственный:</b> ${notification.lead.responsible_user.full_name}</div>`;
                }
            } else if (notification.type === localReferences.entities.deal && notification.deal) {
                card += `<div class="link-listen card-route" data-route="deal-card" data-prop="${notification.deal.id}"><b>Сделка:</b> ${notification.deal.id}</div>`;
                if (notification.deal.responsible_user) {
                    card += `<div class="link-listen"><b>Ответственный:</b> ${notification.deal.responsible_user.full_name}</div>`;
                }
            }

            return card;
        },
        getDataRoute(notification) {
            if (notification.type === localReferences.entities.lead && notification.lead) {
                this.$router.push({
                    name: 'lead-card',
                    params: { id: notification.lead.id }
                });
            } else if (notification.type === localReferences.entities.deal && notification.deal) {
                this.$router.push({
                    name: 'deal-card',
                    params: { id: notification.deal.id }
                });
            }
        },
        getLinkElement(id, elementType, className, content) {
            const route = {
                name: 'task-card',
                params: { id: id }
            };
            const element = document.createElement(elementType);
            if (elementType === 'a') {
                element.href = this.$router.resolve(route).href;
            }
            element.innerHtml = content;
            element.className += ' ' + className;
            element.addEventListener('click', e => {
                e.preventDefault();
                this.$router.push(route);
            });
            return element;
        },
        getNotifyQueueId(notification) {
            if (notification.queue) {
                return notification.queue.id;
            }
            return null;
        },
        closeNotify(currentNotificationId) {
            if (this.notifications) {
                for (const index in this.notifications) {
                    const notification = this.notifications[index];
                    if (notification && Object.prototype.hasOwnProperty.call(notification, 'notify') && Object.prototype.hasOwnProperty.call(notification.notify, 'queueId')) {
                        if (currentNotificationId === notification.notify.queueId) {
                            notification.notify.close();
                            delete this.notifications[notification.notify.queueId];
                        }
                    }
                }
            }
        }
    },
    goLead(id) {
        this.$router.push({ name: 'lead-card', params: { id: '' + id } });
    },
    goDeal(id) {
        this.$router.push({ name: 'deal-card', params: { id: '' + id } });
    },
    goContact(id) {
        this.$router.push({ name: 'contact-card', params: { id: '' + id } });
    },
    goEmployer(id) {
        this.$router.push({ name: 'employer-card', params: { id: '' + id } });
    }
};
</script>
